import React from 'react';
import { Col, Alert, Badge } from 'reactstrap';
import { formatDateToddmmyyhhmm } from '../../../../../../../../../utils/dateformatter';
import {
  hasClauseResponse,
  isEvaluatorResponse,
  toClauseResponseList,
} from '../../../../../../../../../shared/offer-domain/respond';

const MandatoryClauseBadge = () => (
  <span className='badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill fw-medium fs-11'>
    Mandatory
  </span>
);

const ClauseHtmlContent = ({ value }) => {
  if (!value) {
    return <div className='text-dark mb-0 lh-base fs-13'>-</div>;
  }
  return (
    <div
      className='text-dark mb-0 lh-base fs-13'
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
};

const ClauseCard = ({ clause, clauseResponses = {}, index }) => {
  const responseList = toClauseResponseList(clauseResponses[clause.id]);
  const hasSaved = responseList.some(item =>
    hasClauseResponse(item?.respondNotes)
  );
  const isMandatory = clause.isShowToDMUT === true;

  return (
    <Col sm={12} className='mb-2'>
      <div className='rounded-3 overflow-hidden border bg-white'>
        <div className='px-3 py-3 d-flex align-items-center gap-3 border-bottom bg-light-subtle'>
          {index != null && (
            <span
              className='rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 fw-semibold fs-12 bg-light text-muted border'
              style={{ width: '28px', height: '28px' }}
            >
              {index}
            </span>
          )}
          <div className='flex-grow-1' style={{ minWidth: 0 }}>
            <div className='d-flex align-items-center gap-2 flex-wrap'>
              <span className='fw-semibold text-dark fs-14 mb-0'>
                {clause.clauseTitle}
              </span>
              {isMandatory && <MandatoryClauseBadge />}
            </div>
          </div>
        </div>

        <div className='p-3'>
          {isMandatory && (
            <div className='text-danger small fw-medium mb-2'>
              * Mandatory clause for DMUT to fulfill
            </div>
          )}
          <div className='p-3 rounded-3 bg-light-subtle border text-muted fs-13 lh-base mb-3'>
            <ClauseHtmlContent value={clause.clauseDescription} />
          </div>

          {hasSaved ? (
            responseList.map(response => {
              const notes = response?.respondNotes ?? '';
              if (!hasClauseResponse(notes)) return null;

              const evaluatorItem = isEvaluatorResponse(response);
              const metaDate = formatDateToddmmyyhhmm(
                response?.updatedDate || response?.createdDate
              );
              const authorLabel = evaluatorItem
                ? response.createdByLabel || 'PT Pertamina Patra Niaga'
                : response.createdByLabel || 'Counter';

              return (
                <Alert
                  key={response.id ?? `${clause.id}-${metaDate}`}
                  className={`${
                    evaluatorItem
                      ? 'bg-primary-subtle text-primary'
                      : 'bg-success-subtle text-success'
                  } alert-solid alert-label-icon mb-0 mt-2`}
                  fade={false}
                >
                  <i className='ri-chat-3-line label-icon'></i>
                  <div>
                    <div className='d-flex flex-wrap justify-content-between align-items-center gap-2 mb-1'>
                      <div className='d-flex align-items-center gap-2'>
                        <div className='fw-semibold text-dark fs-13'>
                          Respond Notes
                        </div>
                        <Badge
                          color={evaluatorItem ? 'primary' : 'secondary'}
                          className='rounded-pill fs-11'
                        >
                          {evaluatorItem ? 'Evaluator' : 'Counter'}
                        </Badge>
                      </div>
                      <div className='text-muted fs-12'>
                        {authorLabel}
                        {metaDate ? ` · ${metaDate}` : ''}
                      </div>
                    </div>
                    <ClauseHtmlContent value={notes} />
                  </div>
                </Alert>
              );
            })
          ) : (
            <div className='text-muted fs-13 border-top pt-3'>
              No responses yet
            </div>
          )}
        </div>
      </div>
    </Col>
  );
};

export default ClauseCard;
